export default __webpack_public_path__ + "static/media/Sepehr.da65fa4b.jpg";